import React from 'react';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';

const createIcon = (icon: string, symbolsOutlined?: boolean) =>
  function getIcon() {
    return <MaterialIcon icon={icon} symbolsOutlined={symbolsOutlined} />;
  };

const Icons = {
  activate: createIcon('restart_alt', true),
  add: createIcon('add', true),
  archive: createIcon('archive', true),
  arrowBack: createIcon('arrow_back', true),
  build: createIcon('build', true),
  campaign: createIcon('campaign', true),
  checklist: createIcon('checklist', true),
  chevronRight: createIcon('chevron_right', true),
  close: createIcon('check_circle', true),
  construction: createIcon('construction', true),
  copy: createIcon('content_copy', true),
  dashboard: createIcon('dashboard', true),
  deactivate: createIcon('do_not_disturb_on', true),
  delete: createIcon('delete', true),
  download: createIcon('download', true),
  edit: createIcon('edit', true),
  factory: createIcon('factory', true),
  gridView: createIcon('grid_view', true),
  home: createIcon('home', true),
  homePin: createIcon('home_pin', true),
  input: createIcon('input', true),
  interventions: createIcon('build', true),
  inventory: createIcon('inventory', true),
  key: createIcon('key', true),
  link: createIcon('link', true),
  locationOn: createIcon('location_on', true),
  lock: createIcon('lock', false),
  login: createIcon('login', true),
  manageAccounts: createIcon('manage_accounts', true),
  pendingActions: createIcon('pending_actions', true),
  person: createIcon('person', true),
  qrCode: createIcon('qr_code', true),
  schedule: createIcon('schedule', true),
  settings: createIcon('settings', true),
  shareLocation: createIcon('share_location', true),
  sites: createIcon('home_pin', true),
  stopCircle: createIcon('stop_circle', true),
  tasks: createIcon('task_alt', true),
  team: createIcon('group_add', true),
  view: createIcon('visibility', true),
};

export default Icons;
